import { EditQuizWrapperRef, ExemptedStudent } from "@verity/components";
import { useState, useRef, useCallback, useMemo } from "react";

export default function useEditQuizStep() {
	const [editQuizData, setEditQuizData] = useState<ReturnType<EditQuizWrapperRef["getQuizData"]> | undefined>(
		undefined,
	);

	const [uploadedExemptedStudentsMap, setUploadedExemptedStudentsMap] = useState<Map<number, ExemptedStudent>>(
		new Map(),
	);
	const [enforcedProfilesOnly, setEnforcedProfilesOnly] = useState(false);
	const [isFinalEditQuizPage, setIsFinalEditQuizPage] = useState<boolean>(false);
	const [isFirstEditQuizPage, setIsFirstEditQuizPage] = useState<boolean>(true);

	const editQuizRef = useRef<EditQuizWrapperRef>(null);

	const updateEditQuizData = useCallback(() => {
		const data = editQuizRef.current?.getQuizData();
		setEditQuizData(data);
		return data;
	}, []);

	const editQuizWrapperProps = useMemo(() => {
		return {
			uploadedExemptedStudentsMap,
			setUploadedExemptedStudentsMap,
			setIsFinalPage: setIsFinalEditQuizPage,
			setIsFirstPage: setIsFirstEditQuizPage,
			setEnforcedProfilesOnlyEditQuizPage: setEnforcedProfilesOnly,
			forceStartOnFirstPage: false,
		};
	}, [uploadedExemptedStudentsMap]);

	return {
		editQuizData,
		editQuizWrapperProps,
		editQuizRef,
		enforcedProfilesOnly,
		isFinalEditQuizPage,
		isFirstEditQuizPage,
		updateEditQuizData,
	};
}

export type UseEditQuizStepReturn = ReturnType<typeof useEditQuizStep>;
